<template>
    <div class="vue__items-container" :class="{ 'vue__loading' : catalog.loadingCatalog }">
        <div v-if="catalog.loadingCatalog" class="vue__loader"></div>
        <div class="vue__items-header">
            <div class="vue__items-count">
                <p><span>{{ catalog.headers.totalItems }}</span> {{ labels.resultsLabel }}</p>
            </div>
        </div>
        <div class="row vue__items-container-inner" v-cloak>
            <div v-for="product in catalog.items" :key="product.id" class="tile tile--product col-md-4"
                 :class="{ 'tile--project' : catalog.postType == 'projecten' }">
                <a :href="catalog.postType == 'catalogus' ? product.link : fillItemUrl(product.slug, product.images[0])"
                   class="tile__inner tile__inner--no-shadow">
                    <figure class="tile__product-figure" v-if="catalog.postType == 'catalogus'">
                        <img class="tile__product-image" :src="product.meta.image" :alt="product.title.rendered"/>
                    </figure>
                    <figure class="tile__product-figure" v-if="catalog.postType == 'projecten' && product.images[0]">
                        <img class="tile__product-image tile__product-image--is-photo"
                             :src="product.images[0]['url_thumb']" :alt="product.name"/>
                    </figure>
                    <figure class="tile__product-figure tile__product-figure--placeholder"
                            v-if="catalog.postType == 'projecten' && !product.images[0]"></figure>
                    <div class="tile__content">

                        <p class="tile__product-title tile__product-title--in-catalog"
                           v-if="catalog.postType == 'catalogus'" v-html="product.title.rendered"></p>
                        <p class="tile__product-title" v-if="catalog.postType == 'projecten'" v-html="product.name"></p>

                        <p class="tile__product-code" v-if="catalog.postType == 'catalogus'"
                           v-html="product.default_code_stimmt"></p>

                        <p v-if="catalog.postType == 'catalogus' && blogId !== 3" class="tile__product-price">
                            {{ generatePrice(product.meta.list_price) }}</p>
                        <p v-if="product.country_name && product.city && catalog.postType == 'projecten'"
                           class="tile__product-price">{{ product.country_name }}, {{ product.city }}</p>
                    </div>
                </a>
            </div>
        </div>
        <div class="vue__items-footer">
            <div class="vue__items-pagination">
                <sliding-pagination
                        :current="setPagination('current')"
                        :total="catalog.headers.totalPages | parseInt"
                        @page-change="pageChangeHandler"
                ></sliding-pagination>
            </div>
        </div>
    </div>
</template>

<script>

import numberFormatter from 'number-formatter'
import setLanguage from '../mixins/setLanguage'
import setBlogId from '../mixins/setBlogId'
import SlidingPagination from 'vue-sliding-pagination'
import EventBus from '../eventBus'

export default {
    data() {
        return {
            language: String,
            loadingCatalog: true,
            labels: {
                resultsLabel: String
            }
        }
    },
    components: {
        SlidingPagination
    },
    mixins: [setLanguage, setBlogId],
    props: {
        catalog: Object
    },
    created() {
        this.language = this.setLanguage();
        this.blogId = this.setBlogId();
    },
    mounted() {
        this.generateLabels();
    },
    methods: {
        determineLanguage(values = Object) {
            if (typeof values == 'object') {
                let lang = this.language;
                return values[lang];
            } else {
                console.error('Input is not an object, some translations wont show');
            }
        },
        generateLabels() {
            let resultsLabels = {nl: 'resultaten', en: 'results', de: 'ergebnisse'}
            this.labels.resultsLabel = this.determineLanguage(resultsLabels);
        },
        generatePrice(priceData) {
            if (priceData == null || priceData == 0 || priceData == '0' || priceData == false || priceData == 999999 || priceData == '999999') {
                let _this = this;
                let labels = {nl: 'Prijs op aanvraag', en: 'Price on request', de: 'Preis auf anfrage'};
                return _this.determineLanguage(labels);
            } else {
                return numberFormatter("€ #.###,##", priceData);
            }
        },
        pageChangeHandler(selectedPage) {
            this.catalog.headers.currentPage = selectedPage;
            EventBus.$emit('UPDATE_CATALOG_BY_PARAM', selectedPage);

            // Scroll to top of results on page change
            setTimeout(function () {
                document.getElementById('vue__scrollto-container').scrollIntoView({
                    behavior: 'smooth'
                });
            }, 300);
        },
        fillItemUrl(slug, imageArray = null) {
            let deUrl = '/de/standort/';
            if (this.blogId == 3) {
                deUrl = '/standort/'
            }

            let urlPart = {nl: '/locatie/', en: '/location/', de: deUrl};
            let fUrlPart = this.determineLanguage(urlPart);
            let projectUrl = fUrlPart + slug;

            if (imageArray !== null) {
                projectUrl = fUrlPart + slug + '?image=' + imageArray.id;
            }


            return window.location.origin + projectUrl;
        },
        setPagination(type) {
            if (type == 'current') {
                if (window.location.hash) {
                    var url_string = window.location.href;
                    url_string = url_string.replace('#!/', '?');
                    var url = new URL(url_string);
                    var page_param_val = url.searchParams.get("page");
                    if (page_param_val) {
                        return parseInt(page_param_val);
                    } else {
                        return parseInt(this.catalog.headers.currentPage);
                    }
                } else {
                    return parseInt(this.catalog.headers.currentPage);
                }
            }
        }
    },
    filters: {
        parseInt(value) {
            return parseInt(value);
        }
    }
}
</script>
